import React, { useCallback, useEffect, useState } from 'react';
import { UINucleusContentContainer } from '../../../components/UI/NucleusContainer/Content';
import { UIButton, UICard, UICheckbox } from '../../../components/UI';
import { useForm } from 'react-hook-form';
import { useNucleusProviders, ProviderCallRequestConfigResponse } from '../../../context-api/nucleusProvidersContext/NucleusProvidersContext';
import { getProviderCallRequestConfig, updateProviderCallRequestConfig } from '../utils/providerApi';
import Message from '../../../utils/Message';

const ProviderCallRequestConfig = () => {
  const {
    state: {
      provider: {
        data,
        state: { loading },
      },
    },
  } = useNucleusProviders();
  const { handleSubmit } = useForm();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [stateRequestRingtone, setStateRequestRingtone] = useState<string>('Ding');
  const [stateSelectedRequestRingtone, setStateSelectedRequestRingtone] = useState<string>('Ding');
  const [stateAudioCallsEnabled, setStateAudioCallsEnabled] = useState<boolean>(false);
  const [stateSelectedAudioCallsEnabled, setStateSelectedAudioCallsEnabled] = useState<boolean>(false);
  useEffect(() => {
    if (data?.ID) fetchProviderCallRequestConfig(data?.ID);
  }, [data?.ID]);

  const getStringValue = (soundType: number) => {
    if (soundType === 1) return 'Ding';
    if (soundType === 2) return 'Ring';
    if (soundType === 0) return 'Silent';
    return 'Ding';
  };
  const getNumberValue = (soundType: string) => {
    if (soundType === 'Ding') return 1;
    if (soundType === 'Ring') return 2;
    if (soundType === 'Silent') return 0;
    return 1;
  };

  const fetchProviderCallRequestConfig = async (providerId): Promise<ProviderCallRequestConfigResponse> => {
    setIsLoading(true);
    const response = await getProviderCallRequestConfig(providerId);
    if (response?.ID) {
      setStateRequestRingtone(getStringValue(response?.CallRequestRingtone));
      setStateSelectedRequestRingtone(getStringValue(response?.CallRequestRingtone));
      setStateAudioCallsEnabled(response?.AudioCallsEnabled);
      setStateSelectedAudioCallsEnabled(response?.AudioCallsEnabled);
    }
    setIsLoading(false);
    return response;
  };

  const disableSubmit = useCallback(() => {
    if (stateRequestRingtone !== stateSelectedRequestRingtone || stateAudioCallsEnabled !== stateSelectedAudioCallsEnabled) {
      return false;
    }
    return true;
  }, [data, isLoading, stateSelectedRequestRingtone, stateSelectedAudioCallsEnabled]);

  const handleRequestSoundChange = (event) => {
    setStateSelectedRequestRingtone(event.target.value);
  };

  const handleAudioCallsEnable = (value: boolean) => {
    setStateSelectedAudioCallsEnabled(value);
  };

  const onSubmitCallRequestConfig = async (formData) => {
    if (!data?.ID) return;
    const formValues = {
      CallRequestRingtone: getNumberValue(stateSelectedRequestRingtone),
      AudioCallsEnabled: stateSelectedAudioCallsEnabled,
    };
    setIsLoading(true);
    const response = await updateProviderCallRequestConfig({
      providerId: data?.ID,
      callRequestConfigForm: formValues,
    });
    setIsLoading(false);
    if (response?.providerCallRequestConfigUpdate) {
      Message.show('Provider Call Request Queue ringtone Config updated');
      fetchProviderCallRequestConfig(data?.ID);
    } else {
      Message.error('Error updating Provider Escalation Config');
    }
  };

  return (
    <UINucleusContentContainer style={{ paddingTop: 30 }}>
      <UICard
        title="Provider Portal Settings"
        cardHeaderStyle={{
          fontFamily: 'Barlow',
          fontSize: '20px',
          fontStyle: 'italic',
          fontWeight: 500,
          lineHeight: '24px',
          letterSpacing: '0px',
          textAlign: 'left',
        }}
        style={{
          backgroundColor: '#EBF2FE',
          width: '24vw',
          paddingBottom: 20,
        }}
      >
        <UINucleusContentContainer>
          <div
            style={{
              display: 'flex',
              width: '50%',
              flexDirection: 'row',
              marginBottom: 24,
              gap: 24,
            }}
          >
            <div>
              <input
                type="radio"
                name="callRequestDing"
                id="callRequestDing"
                value="Ding"
                checked={stateSelectedRequestRingtone === 'Ding'}
                onChange={handleRequestSoundChange}
                className="with-gap"
                disabled={false}
              />
              <label htmlFor="callRequestDing" id="callRequestDing" style={{ color: '#0A313F', paddingLeft: 24 }}>
                <span>Ding</span>
              </label>
            </div>
            <div>
              <input
                type="radio"
                name="callRequestRing"
                id="callRequestRing"
                value="Ring"
                checked={stateSelectedRequestRingtone === 'Ring'}
                onChange={handleRequestSoundChange}
                className="with-gap"
                disabled={false}
              />
              <label htmlFor="callRequestRing" id="callRequestRing" style={{ color: '#0A313F', paddingLeft: 24 }}>
                <span>Ring</span>
              </label>
            </div>
            <div>
              <input
                type="radio"
                name="callRequestSilent"
                id="callRequestSilent"
                value="Silent"
                checked={stateSelectedRequestRingtone === 'Silent'}
                onChange={handleRequestSoundChange}
                className="with-gap"
                disabled={false}
              />
              <label htmlFor="callRequestSilent" id="callRequestSilent" style={{ color: '#0A313F', paddingLeft: 24 }}>
                <span>Silent</span>
              </label>
            </div>
          </div>
          <div style={{ marginBottom: 30 }}>
            <label htmlFor="audioCallsEnabled" id="audioCallsEnabled" style={{ color: '#0A313F', fontWeight: 600, fontSize: 16 }}>
              <p style={{ marginBottom: 5 }}>Audio Calls:</p>
            </label>
            <div style={{ maxWidth: 293, minWidth: 200, height: 50, backgroundColor: '#FFFFFF', display: 'flex', alignItems: 'center', justifyContent: 'space-evenly' }}>
              <label>
                <span style={{ fontSize: 16, fontWeight: 300, color: '#0A313F' }}>Enable audio calls in queue</span>
              </label>
              <UICheckbox checked={stateSelectedAudioCallsEnabled} onClick={handleAudioCallsEnable} />
            </div>
          </div>
          <UIButton disabled={disableSubmit()} onClick={handleSubmit(onSubmitCallRequestConfig)} text="Save" variant={disableSubmit() === true ? 'disabled' : 'primary'} />
        </UINucleusContentContainer>
      </UICard>
    </UINucleusContentContainer>
  );
};

export default ProviderCallRequestConfig;
